export default {
  loginUrl: 'https://app.qmclouds.com/login',
  home: '/',
};
